module.exports = __webpack_public_path__ + "static/header-add3d946c21dd521b32e826160a3291a.png";